/**
 * RaceScene - Racing car mini-game
 */

import { useState, useEffect } from 'react';

export default function RaceScene({ level, isComplete, isListening }) {
  const [position, setPosition] = useState(0);
  const [finished, setFinished] = useState(false);

  useEffect(() => {
    setPosition(0);
    setFinished(false);
  }, [level?.id]);

  useEffect(() => {
    if (isComplete && !finished) {
      const interval = setInterval(() => {
        setPosition(prev => {
          if (prev >= 100) {
            setFinished(true);
            return 100;
          }
          return prev + 5;
        });
      }, 50);
      return () => clearInterval(interval);
    }
  }, [isComplete, finished]);

  return (
    <div style={styles.scene}>
      <div style={styles.sky} />
      <div style={styles.track}>
        <div style={styles.laneLine} />
        <div style={{ ...styles.car, left: `${5 + position * 0.75}%` }}>
          🏎️
          {(isListening || isComplete) && !finished && <div style={styles.exhaust}>💨</div>}
        </div>
        <div style={styles.finish}>🏁</div>
      </div>
      {finished && <div style={styles.trophy}>🏆</div>}
      <div style={styles.status}>
        {finished ? 'YOU WIN!' : isListening ? 'Say "GO FAST"!' : 'Ready...'}
      </div>
    </div>
  );
}

const styles = {
  scene: { position: 'absolute', inset: 0, overflow: 'hidden' },
  sky: { position: 'absolute', inset: 0, background: 'linear-gradient(180deg, #38bdf8 0%, #7dd3fc 100%)' },
  track: { position: 'absolute', bottom: '20%', left: 0, right: 0, height: '25%', background: '#374151', borderTop: '5px solid white', borderBottom: '5px solid white' },
  laneLine: { position: 'absolute', top: '50%', left: 0, right: 0, height: '4px', background: 'repeating-linear-gradient(90deg, white 0px, white 30px, transparent 30px, transparent 60px)' },
  car: { position: 'absolute', top: '50%', transform: 'translateY(-50%)', fontSize: '50px', transition: 'left 0.05s linear', filter: 'drop-shadow(0 5px 10px rgba(0,0,0,0.3))' },
  exhaust: { position: 'absolute', left: '-30px', top: '50%', transform: 'translateY(-50%)', fontSize: '25px', opacity: 0.7 },
  finish: { position: 'absolute', right: '5%', top: '50%', transform: 'translateY(-50%)', fontSize: '50px' },
  trophy: { position: 'absolute', top: '20%', left: '50%', transform: 'translateX(-50%)', fontSize: '80px', animation: 'trophyBounce 0.5s ease' },
  status: { position: 'absolute', top: '10%', left: '50%', transform: 'translateX(-50%)', background: 'rgba(0,0,0,0.6)', color: 'white', padding: '12px 24px', borderRadius: '30px', fontFamily: "'Fredoka', sans-serif", fontSize: '18px', fontWeight: 600 },
};
